import { createAction } from 'redux-actions';

export default {
  getAllParameters: createAction('parameters/GET_ALL_PARAMETERS'),
  updateParametersList: createAction('parameters/UPDATE_PARAMETERS_LIST'),
  saveParameter: createAction('parameters/SAVE_PARAMETER'),
};
